import { render, staticRenderFns } from "./OnboardingPopup.vue?vue&type=template&id=5dd3d574&scoped=true&"
import script from "./OnboardingPopup.vue?vue&type=script&lang=js&"
export * from "./OnboardingPopup.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPopup.vue?vue&type=style&index=0&id=5dd3d574&lang=less&module=true&scoped=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./OnboardingPopup.vue?vue&type=style&index=0&id=5dd3d574&lang=less&module=true&scoped=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./OnboardingPopup.vue?vue&type=style&index=0&id=5dd3d574&lang=less&module=true&scoped=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("5dd3d574")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5dd3d574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd3d574')) {
      api.createRecord('5dd3d574', component.options)
    } else {
      api.reload('5dd3d574', component.options)
    }
    module.hot.accept("./OnboardingPopup.vue?vue&type=template&id=5dd3d574&scoped=true&", function () {
      api.rerender('5dd3d574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/onboarding/OnboardingPopup.vue"
export default component.exports